import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../../components/marketing/Header';
import Footer from '../../components/marketing/Footer';
import ScrollToTop from '../../components/marketing/ScrollToTop';
import AccessibilityWidget from '../../components/marketing/AccessibilityWidget';
import { RTL_LANGUAGES } from '../../i18n';

export default function MarketingLayout() {
  const { i18n } = useTranslation();
  const isRTL = RTL_LANGUAGES.includes(i18n.language);

  useEffect(() => {
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = i18n.language;
  }, [i18n.language, isRTL]);

  return (
    <div dir={isRTL ? 'rtl' : 'ltr'} className="min-h-screen flex flex-col" style={{ fontFamily: "'Heebo', 'Noto Sans Arabic', system-ui, sans-serif" }}>
      <ScrollToTop />
      <Header />
      <main id="main-content" className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <AccessibilityWidget />
    </div>
  );
}
